<template>
  <b-card border-variant="dark">
    <div id="chart1">
      <apexchart type="donut" :options="chartOptions" :series="series" ref="realtimeResp"></apexchart>
    </div>
  </b-card>
</template>

<script>
const socket = require('./../../../modules/realtime/service/service');

export default {
  name: "GraficoRespondids",

  data: () => ({
    chartOptions: {
      chart: { type: 'donut' },
      labels: ['Em atendimento', 'Aguardando atendimento'],
      colors: ['#23ed87', '#fe0000'],
      legend: { position: 'bottom', horizontalAlign: 'center' },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                label: 'Total',
                color: '#939595',
                formatter(w) {
                  return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                }
              }
            }
          }
        }
      },
      responsive: [{
        breakpoint: 480,
        options: { chart: { width: 200 }, legend: { position: 'bottom' } }
      }],
    },

    series: [0, 0],

    _realtimeJoined: false,
    _onDetailAllBound: null,
    _onReconnectBound: null,
  }),

  mounted() {
    this.joinRealtime();
  },
  beforeDestroy() { this.leaveRealtime(); },
  deactivated()   { this.leaveRealtime(); },
  activated()     { this.joinRealtime(); },

  methods: {
    joinRealtime() {
      if (this._realtimeJoined) return;

      socket.connection.emit('realtime:join');

      this._onDetailAllBound = (obj) => {
        const a = Number(obj?.queues?.atendimento || 0);
        const g = Number(obj?.queues?.aguardando || 0);
        this.series = [a, g];
      };
      socket.connection.on('queueDetailAll', this._onDetailAllBound);

      this._onReconnectBound = () => {
        if (this._realtimeJoined) socket.connection.emit('realtime:join');
      };
      socket.connection.on('connect', this._onReconnectBound);

      this._realtimeJoined = true;
    },

    leaveRealtime() {
      if (!this._realtimeJoined) return;

      socket.connection.emit('realtime:leave');

      if (this._onDetailAllBound) {
        if (socket.connection.off) socket.connection.off('queueDetailAll', this._onDetailAllBound);
        else socket.connection.removeListener('queueDetailAll', this._onDetailAllBound);
        this._onDetailAllBound = null;
      }
      if (this._onReconnectBound) {
        if (socket.connection.off) socket.connection.off('connect', this._onReconnectBound);
        else socket.connection.removeListener('connect', this._onReconnectBound);
        this._onReconnectBound = null;
      }

      this._realtimeJoined = false;
    }
  }
};
</script>


<style scoped>
  .card {
    color: black !important;
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    border-radius: 0.25rem !important;
  }
</style>